export class Module{
    answered: number;
    description: string;
    haveNextModule: boolean;
    id: number;
    moduleNumber: number;
    name: string;
    totalQuestions: number;
    videoUrl: string = '';
}